import { produce } from "immer";
import {
  ADD_FEED,
  ADD_FEED_FAILURE,
  ADD_FEED_SUCCESS,
  //
  DELETE_FEED,
  DELETE_FEED_FAILURE,
  DELETE_FEED_SUCCESS,
  //
  EDIT_FEED,
  EDIT_FEED_FAILURE,
  EDIT_FEED_SUCCESS,
  //
  FETCH_FEEDS,
  FETCH_FEEDS_FAILURE,
  FETCH_FEEDS_SUCCESS,
  GET_FEED_STATS,
  GET_FEED_STATS_FAILURE,
  GET_FEED_STATS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_FEED_ADD_MODAL,
  //
  SET_FEED_FILTER,
  //
  UPDATE_FORM_VALUES,
  UPDATE_MEDIA_FILES,
  UPDATE_MEDIA_LINKS,
  RESET_FORM_VALUES,
  TOGGLE_DELETE,
  //
  ADD_VOTE,
  ADD_VOTE_SUCCESS,
  ADD_VOTE_FAILURE,
  ADD_EVENT_RSVP,
  ADD_EVENT_RSVP_SUCCESS,
  ADD_EVENT_RSVP_FAILURE,
} from "./constants";
import { RECORD_FEED_VIEW_SUCCESS } from "../FeedAction/constants";

export const initialState = {
  isFetchingFeeds: false,
  isFetchingFeedStats: false,
  feedTypeCounts: null,
  feeds: {},
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentFeed: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  //
  feedAddModal: {
    open: false,
    isEditing: false,
  },
  feedFilters: {
    target: "all",
    page: 1,
    limit: 10,
  },
  formValues: {
    title: "",
    description: "",
    feed_type: "company update",
    kudos_type: "",
    kudos_value_0: "",
    kudos_value_1: "",
    kudos_value_2: "",
    kudos_value_3: "",
    // interaction
    is_acknowledgement_required: false,
    is_comment_disabled: false,
    is_reaction_disabled: false,
    // visibility
    target: "location",
    location_id: "",
    target_employee_id: "",
    team_id: "",
    // poll
    poll_type: "text",
    question: "",
    options: [],
    allow_multiple: false,
    show_results_after_vote: false,
    expires_at: "",
    // event feed
    event_date: "",
    event_start_time: "",
    event_end_time: "",
    event_location: "",
  },
  mediaFiles: [],
  mediaLinks: [],
  deleteFeedData: {
    open: false,
  },
  //
  isVoting: false,
  isEventRsvpSubmitting: false,
};

const FeedReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_FEEDS:
        draft.isFetchingFeeds = true;
        break;
      case FETCH_FEEDS_SUCCESS:
        draft.isFetchingFeeds = false;
        draft.feeds = action.payload;
        break;
      case FETCH_FEEDS_FAILURE:
        draft.isFetchingFeeds = false;
        draft.feeds = {};
        break;

      case GET_FEED_STATS:
        draft.isFetchingFeedStats = true;
        break;
      case GET_FEED_STATS_SUCCESS:
        draft.isFetchingFeedStats = false;
        draft.feedTypeCounts = action.payload ?? null;
        break;
      case GET_FEED_STATS_FAILURE:
        draft.isFetchingFeedStats = false;
        break;

      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentFeed = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentFeed = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentFeed = {};
        break;
      case RECORD_FEED_VIEW_SUCCESS: {
        const feedId = action.payload?.feedId;
        const feedSeenCount = action.payload?.data?.feed_seen_count;

        if (!feedId) break;

        if (Array.isArray(draft.feeds?.data)) {
          draft.feeds.data = draft.feeds.data.map((feed) =>
            feed?.id === feedId
              ? { ...feed, feed_seen_count: feedSeenCount }
              : feed,
          );
        }

        if (draft.currentFeed?.id === feedId) {
          draft.currentFeed = {
            ...draft.currentFeed,
            feed_seen_count: feedSeenCount,
          };
        }
        break;
      }
      // Add
      case ADD_FEED:
        draft.isSubmitting = true;
        break;
      case ADD_FEED_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_FEED_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_FEED:
        draft.isSubmitting = true;
        break;
      case EDIT_FEED_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_FEED_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_FEED:
        draft.isDeleting = true;
        break;
      case DELETE_FEED_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_FEED_FAILURE:
        draft.isDeleting = false;
        break;
      //
      case TOGGLE_FEED_ADD_MODAL:
        draft.feedAddModal = action.payload;
        break;

      case SET_FEED_FILTER:
        draft.feedFilters = action.payload;
        break;

      case UPDATE_FORM_VALUES:
        draft.formValues = { ...draft.formValues, ...action.payload };
        break;

      case UPDATE_MEDIA_FILES:
        draft.mediaFiles = action.payload;
        break;

      case UPDATE_MEDIA_LINKS:
        draft.mediaLinks = action.payload;
        break;

      case RESET_FORM_VALUES:
        draft.formValues = initialState.formValues;
        draft.mediaFiles = [];
        draft.mediaLinks = [];
        break;

      case TOGGLE_DELETE:
        draft.deleteFeedData = action.payload;
        break;

      case ADD_VOTE:
        draft.isVoting = true;
        break;
      case ADD_VOTE_SUCCESS:
        draft.isVoting = false;
        break;
      case ADD_VOTE_FAILURE:
        draft.isVoting = false;
        break;

      case ADD_EVENT_RSVP:
        draft.isEventRsvpSubmitting = true;
        break;
      case ADD_EVENT_RSVP_SUCCESS:
        draft.isEventRsvpSubmitting = false;
        break;
      case ADD_EVENT_RSVP_FAILURE:
        draft.isEventRsvpSubmitting = false;
        break;

      default:
        return state;
    }
  });

export default FeedReducer;
